export const CreatedUsersTypes = [
  { label: 'Mağaza', value: 'corporational' },
  { label: 'Porter', value: 'porter' },
];
